/*
 * @Descripttion:
 * @version:
 * @Author: gjqiang
 * @Date: 2021-5-25 15:09:17
 */
// 常用状态

export const ROLE_STORE_ACCOUNT = [6,15,21] // 门店账号
export const ROLE_SERVER_ACCOUNT = 7 // 服务人员账号
